export default __webpack_public_path__ + "static/media/fb.d2defb32.svg";